import React from "react";
import LandingSimpleSection from "@insightfulscience/atomic-react/LandingElement/SimpleSection";
import { Col, Container, Row } from "@insightfulscience/atomic-react/Grid";
import { arrayOf, shape, string } from "prop-types";
import Section from "@insightfulscience/atomic-react/Section";
import { PostElementTitleH3 } from "@insightfulscience/atomic-react/PostElement";
import UList from "@insightfulscience/atomic-react/UList";
import AcademyToCLink from "./AcademyToCLink";

const AcademyToC = ({ items }) => {
	return (
		<Section spacing={{ mt: 12 }}>
			<PostElementTitleH3 center className="mb-6">
				Course Content
			</PostElementTitleH3>
			<LandingSimpleSection.Body>
				<Container>
					<Row utility={{ justify: "center" }}>
						<Col lg="shrink">
							<Row mx my utility={{ justify: "between" }}>
								<Col
									sm={12}
									md="shrink"
									utility={{
										border: { left: { width: 1, color: "dotmatics-1" } },
									}}
								>
									<UList spacing={{ ml: 5 }}>
										{items.map((item, key) => {
											if (key % 2 === 0) {
												return (
													<AcademyToCLink
														title={item.title}
														slug={item.slug}
														key={items.indexOf(item)}
													/>
												);
											}
											return null;
										})}
									</UList>
								</Col>
								<Col
									sm={12}
									md="shrink"
									utility={{
										border: { left: { width: 1, color: "dotmatics-1" } },
									}}
								>
									<UList spacing={{ ml: 5 }}>
										{items.map((item, key) => {
											if (key % 2 !== 0) {
												return (
													<AcademyToCLink
														title={item.title}
														slug={item.slug}
														key={items.indexOf(item)}
													/>
												);
											}
											return null;
										})}
									</UList>
								</Col>
							</Row>
						</Col>
					</Row>
				</Container>
			</LandingSimpleSection.Body>
		</Section>
	);
};

AcademyToC.propTypes = {
	items: arrayOf(
		shape({
			title: string.isRequired,
			slug: string.isRequired,
		}),
	).isRequired,
};

export default AcademyToC;
